"use strict";

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var logger_1 = require("./logger");

var log = logger_1.Logger.scope('UserDescriptor');

function parseAttributes(attrs) {
  try {
    return JSON.parse(attrs);
  } catch (e) {
    log.warn('Failed to parse user attributes', e);
  }

  return {};
}
/**
 * @classdesc Extended user information.
 * Note that <code>online</code> and <code>notifiable</code> properties are eligible
 * to use only if reachability function is enabled.
 * You may check if it is enabled by reading value of {@link Client}'s <code>reachabilityEnabled</code> property.
 *
 * @property {String} identity - User identity
 * @property {String} friendlyName - User friendly name, null if not set
 * @property {Object} attributes - Object with custom attributes for user
 * @property {Boolean} online - User real-time channel connection status
 * @property {Boolean} notifiable - User push notification registration status
 *
 * @constructor
 * @param {Users} users Users instance
 * @param {Object} descriptor User descriptor data object
 */


var UserDescriptor = function () {
  /**
   * @param {UserDescriptorServices} services - services, needed for UserDescriptor
   * @param {Object} descriptor User descriptor data object
   * @private
   */
  function UserDescriptor(services, descriptor) {
    (0, _classCallCheck3.default)(this, UserDescriptor);
    this.services = services;
    this.descriptor = descriptor;
    this.identity = descriptor.identity;
    this.friendlyName = descriptor.friendly_name;
    this.attributes = parseAttributes(descriptor.attributes);
    this.online = descriptor.is_online;
    this.notifiable = descriptor.is_notifiable;
  }
  /**
   * Gets User object from descriptor and subscribes to it.
   * @returns {Promise<User>}
   */


  (0, _createClass3.default)(UserDescriptor, [{
    key: "subscribe",
    value: function subscribe() {
      return this.services.users.getUser(this.identity, this.descriptor.sync_unique_name);
    }
  }, {
    key: "_getDescriptor",
    value: function _getDescriptor() {
      return this.descriptor;
    }
  }]);
  return UserDescriptor;
}();

exports.UserDescriptor = UserDescriptor;